import * as React from "react";
function SvgArrowCornerRight(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#arrow-corner-right_svg__clip0_23_8)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.657 16.25v-9.9a1 1 0 00-1-1h-9.9v2h7.486L4.929 17.664l1.414 1.414L16.657 8.765v7.485h2z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="arrow-corner-right_svg__clip0_23_8">
                    <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgArrowCornerRight);
export default ForwardRef;
